import React from 'react';
import {useIntl} from 'react-intl';
import messages from '../../../../res/translations/messages';

const formatDate = (date, intl) => date ? intl.formatDate(date) : intl.formatMessage(messages.waves.dateNotSet);

const WaveSelect = ({value, items, ...rest}) => {
    const intl = useIntl();
    const wavesReversed = items.slice(0).reverse();
    return (
        <select value={value.id} {...rest}>
            {wavesReversed.map((w) => (
                <option key={w.id} value={w.id}>
                    {w.name}
                    {w.startDate || w.endDate ? ` [${formatDate(w.startDate, intl)} - ${formatDate(w.endDate, intl)}]` : ''}
                </option>
            ))}
        </select>
    );
};

export default WaveSelect;
